import localFont from 'next/font/local';

const apercuNormal = localFont({
  variable: '--font-apercu-normal',
  src: '../../../fonts/apercu-regular.woff2',
  display: 'swap',
  weight: '400',
});

const apercuBold = localFont({
  variable: '--font-apercu-bold',
  src: '../../../fonts/apercu-bold.woff2',
  display: 'swap',
  weight: '700',
});

const apercuItalic = localFont({
  variable: '--font-apercu-italic',
  src: '../../../fonts/apercu-italic.woff2',
  display: 'swap',
  weight: '400',
});

const apercuMono = localFont({
  variable: '--font-apercu-mono',
  src: '../../../fonts/apercu-mono-regular.woff2',
  style: 'normal',
  weight: '400',
});

export default {
  apercuNormal,
  apercuBold,
  apercuItalic,
  apercuMono,
};
